import React, { useState } from 'react';
import invoiceService from '../services/invoiceService';

const InvoiceDownloadButton = ({ invoice, variant = 'icon', className, onError }) => {
  const [downloading, setDownloading] = useState(false);

  if (!invoice) return null;

  const handleDownload = async () => {
    setDownloading(true);
    try {
      const blob = await invoiceService.downloadPdf(invoice.id);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `rechnung_${invoice.invoice_number.replace(/-/g, '_')}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      const msg = 'Fehler beim Herunterladen der Rechnung: ' + err.message;
      if (onError) onError(msg);
      else window.alert(msg);
    } finally {
      setDownloading(false);
    }
  };

  const title = `Rechnung ${invoice.invoice_number} herunterladen`;

  if (variant === 'full') {
    return (
      <button
        type="button"
        className={className || 'btn btn-primary'}
        onClick={handleDownload}
        disabled={downloading}
        title={title}
      >
        📄 {downloading ? 'Wird geladen…' : 'PDF herunterladen'}
      </button>
    );
  }

  return (
    <button
      type="button"
      className={className || 'action-btn download-btn'}
      onClick={handleDownload}
      disabled={downloading}
      title={title}
    >
      📄
    </button>
  );
};

export default InvoiceDownloadButton;
